import "./style.css";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import IconButton from "@material-ui/core/IconButton";

import SliderEstimate from "./components/Slider/Slider_desktop";

import { fetchData, calcBrandValues } from "./dataFetcherBrandCalc";
import { useEffect, useState } from "react";
import formatNumberToAbbString from "../../../../helpers/formatNumberToAbbString";
import { Link } from "react-router-dom";
import SliderLayout from "./components/Slider";
import UnicornIndicatorLayout from "./components/UnicornIndicator";
import store from "../../../../store/store";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    width: "100%",
    margin: "0 auto",
    padding: theme.spacing(2),
  },
}));

const selectWindowInnerSize = (state) => state.windowInnerSize;

const EstimateSlide = (props) => {
  const classes = useStyles();

  const windowInnerSize = useSelector(selectWindowInnerSize);

  const [brandCalculatorData, setBrandCalculatorData] = useState(null);
  useEffect(() => {
    async function fetchDataAndUpdate() {
      const fetchedData = await fetchData();
      fetchData.response && setBrandCalculatorData(fetchedData);
    }
    setBrandCalculatorData(store.getState().moneyCalculatorValues);
    fetchDataAndUpdate();
  }, []);

  const [SMfollowers, setSMfollowers] = useState({
    tiktok: 0,
    instagram: 0,
    youtube: 0,
  });
  const [totalEarnings, setTotalEarnings] = useState({ min: 0, max: 0 });
  const [totalWorth, settotalWorth] = useState({ min: 0, max: 0 });
  const [unicornRatio, setunicornRatio] = useState(0);
  function calcBrand(followers) {
    // console.log(followers);
    return calcBrandValues(followers, brandCalculatorData);
  }
  function setTiktokFollowers(followers) {
    // console.log('p' + followers);
    let temp = { ...SMfollowers, tiktok: followers };
    // console.log(temp);
    setSMfollowers(temp);
  }
  function setInstagramFollowers(followers) {
    let temp = { ...SMfollowers, instagram: followers };
    setSMfollowers(temp);
  }
  function setYoutubeFollowers(followers) {
    let temp = { ...SMfollowers, youtube: followers };
    setSMfollowers(temp);
  }
  useEffect(() => {
    if (brandCalculatorData) {
      let totalFollowers =
        SMfollowers.tiktok + SMfollowers.instagram + SMfollowers.youtube;
      let brandValues = calcBrand(totalFollowers, brandCalculatorData);
      setTotalEarnings(brandValues.earnings);
      settotalWorth(brandValues.worth);
      let tempUnicornRatio = +brandValues?.worth.min / 10000000;
      tempUnicornRatio = tempUnicornRatio > 100 ? 100 : tempUnicornRatio;
      setunicornRatio(tempUnicornRatio);
    }
  }, [SMfollowers, brandCalculatorData]);

  return (
    brandCalculatorData && (
      <div
        className={classes.root}
        style={{
          position: "relative",
          width: "100vw",
          minHeight: windowInnerSize.height,
          display: "flex",
          flexDirection: "column",
          paddingBottom: "20vh",
          zIndex: "2",
        }}
      >
        <div
          style={{ position: "relative", margin: "auto 0", padding: "50px 0" }}
        >
          <p
            className={"LandingPage__WhereTxt unnamed-character-style-1"}
            style={{
              fontSize: props.isPhone ? "18px" : "32px",
              lineHeight: props.isPhone ? "24px" : "",
              textShadow: props.isPhone
                ? "0 0 0.2vw #fff, 0 0 2.35vw #fff, 0 0 5.1vw #ffbf12"
                : "0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12",
            }}
          >
            Check your social media accounts' worth
          </p>
          <p
            className="headline"
            style={{
              fontSize: props.isPhone ? "12px" : "16px",
              lineHeight: props.isPhone ? "15px" : "20px",
              color: "#a1a1a1",
              fontWeight: "lighter",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            Use the slider or enter your follower count to estimate your social
            media accounts' worth, IPO readiness and projected cash earnings on
            PassionStocks.
            <br />
            Your social media accounts' worth reflects your personal brand's
            worth. This calculator is for content creators of all types.{" "}
          </p>
          <div
            // container
            // spacing={3}
            style={{
              display: "flex",
              width: props.isPhone ? "100%" : "fit-content",
              position: "relative",
              margin: "0 auto",
              alignItems: "center",
              justifyContent: props.isPhone ? "space-between" : "center",
              flexDirection: props.isPhone ? "row" : "column",
            }}
          >
            {!props.isPhone && (
              <Typography
                className="headline"
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  fontSize: "11px",
                  width: "163px",
                  padding: "0 24px 0 0",
                  textAlign: "center",
                  color: "#909090",
                }}
              >
                *Account Worth Range
              </Typography>
            )}
            {/* <Grid item className={classes.sliderContainer}> */}

            <SliderLayout
              icon="/images/ig-yt-tt-icons.png"
              alt="Tiktok"
              padding="15px 70px 12px 70px"
              width="100px"
              calcBrand={calcBrand}
              setFollowers={setTiktokFollowers}
              isPhone={props.isPhone}
            />
            {/* </Grid> */}
            <SliderLayout
              // icon="/images/instagram-icon.svg"
              label="other platforms"
              // alt="Instagram"
              // padding="20px 35px 12px "
              // width="27px"
              calcBrand={calcBrand}
              setFollowers={setInstagramFollowers}
              isPhone={props.isPhone}
            />

            {/* <SliderLayout
              youtube
              icon="/images/youtube-icon.svg"
              alt="Youtube"
              padding="20px 35px 12px"
              width="29px"
              calcBrand={calcBrand}
              setFollowers={setYoutubeFollowers}
              isPhone={props.isPhone}
            /> */}
          </div>
          {props.isPhone && (
            <p
              className="headline"
              style={{
                margin: "0 0 0 20px",
                color: "#909090",
                fontSize: "10px",
                lineHeight: "20px",
                fontWeight: "lighter",
              }}
            >
              <span style={{ fontSize: "20px", lineHeight: "0" }}>_</span>
              <br />
              <span
                style={{
                  fontSize: "6px",
                  fontWeight: "bolder",
                  verticalAlign: "text-bottom",
                }}
              >
                |{" "}
              </span>
              Account worth range
            </p>
          )}
          <p
            className={"LandingPage__WhereTxt unnamed-character-style-1"}
            style={{
              fontSize: props.isPhone ? "18px" : "23px",
              lineHeight: props.isPhone ? "22px" : "",
              marginBottom: props.isPhone ? "10px" : "",
              margin: props.isPhone ? "35px auto 10px" : "12px auto 0px",
              textShadow: props.isPhone
                ? "0 0 0.2vw #fff, 0 0 2.35vw #fff, 0 0 5.1vw #ffbf12"
                : "0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12",
            }}
          >
            Stock exchange listing (IPO) readiness{" "}
          </p>
          <div className="MyBrandStats__IpoProgressContainer">
            <UnicornIndicatorLayout
              isPhone={props.isPhone}
              totalWorth={totalWorth}
              unicornRatio={unicornRatio}
            />
            <div>
              <div
                className="Estimate__WorthRangesContainer unnamed-character-style-1"
                style={{
                  display: props.isPhone ? "block" : "flex",
                  marginTop: props.isPhone ? "20px" : "30px",
                }}
              >
                <div
                  style={
                    props.isPhone
                      ? null
                      : { maxWidth: "320px", margin: "0 20px" }
                  }
                >
                  <p
                    className="unnamed-character-style-1"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: "15px",
                      margin: "0",
                      lineHeight: "20px",
                      textAlign: "center",
                      color: "#ffbf12",
                    }}
                  >
                    Est. accounts’ Worth
                    <img
                      src="/images/stocks.svg"
                      alt="Stocks value"
                      style={{ width: "14px", marginLeft: "5px" }}
                    />
                  </p>
                  <p
                    style={{
                      fontWeight: "normal",
                      color: "#707070",
                      fontSize: "12px",
                      lineHeight: "16px",
                      textAlign: "center",
                    }}
                  >
                    *your current social media accounts’ <br />
                    est. worth ranges from
                  </p>
                  <p
                    style={{
                      color: "#ffbf12",
                      fontSize: "20px",
                      lineHeight: "18px",
                      margin: "0 10px",
                      textAlign: "center",
                    }}
                  >
                    ~ ${formatNumberToAbbString(totalWorth?.min)} - $
                    {formatNumberToAbbString(totalWorth?.max)}
                  </p>
                </div>
                <div
                  style={
                    props.isPhone
                      ? { marginTop: "20px" }
                      : { maxWidth: "320px", margin: "0 20px" }
                  }
                >
                  <p
                    className="unnamed-character-style-1"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "bold",
                      fontSize: "15px",
                      margin: "0",
                      lineHeight: "20px",
                      textAlign: "center",
                      color: "#ffbf12",
                    }}
                  >
                    Projected cash earnings{" "}
                    <img
                      src="/images/cash.svg"
                      alt="Cash earning"
                      style={{ width: "16px", marginLeft: "5px" }}
                    />
                  </p>
                  <p
                    style={{
                      fontWeight: "normal",
                      color: "#707070",
                      fontSize: "12px",
                      lineHeight: "16px",
                      textAlign: "center",
                    }}
                  >
                    *Your projected earnings <br />
                    on Passionstocks (next 12 months) range from
                  </p>
                  <p
                    style={{
                      color: "#ffbf12",
                      fontSize: "20px",
                      lineHeight: "18px",
                      margin: "0 10px",
                      textAlign: "center",
                    }}
                  >
                    ~ ${formatNumberToAbbString(totalEarnings?.min)} - $
                    {formatNumberToAbbString(totalEarnings?.max)}{" "}
                  </p>
                </div>
              </div>
              <div
                style={{
                  margin: props.isPhone ? "20px 3vw" : "26px 10px 10px 47px",
                }}
              >
                <p
                  className="headline"
                  style={{
                    color: "#707070",
                    fontSize: "11px",
                    lineHeight: "20px",
                    fontWeight: "lighter",
                    textAlign: "center",
                    margin: 0,
                    width: "fit-content",
                  }}
                >
                  * Estimates are based on projected AI Agent{" "}
                  <Link
                    to="https://support.passionstocks.com/categories/29949-shoutouts"
                    style={{ textDecoration: "underline" }}
                  >
                    shoutout sales
                  </Link>{" "}
                  on PassionStocks with a 1% annual follower conversion rate only.
                  Other income is excluded. These estimates could be completely wrong.{" "}
                  <Link
                    to="https://support.passionstocks.com/categories/29955-personal-brand-calculator"
                    style={{ textDecoration: "underline" }}
                  >
                    Learn more
                  </Link>
                </p>
              </div>
            </div>
          </div>

          {/* 
          <div
            className="headline"
            style={{
              display: 'flex',
              justifyContent: 'space-evenly',
              alignItems: 'center',
              fontSize: '11px',
              fontWeight: 'lighter',
              marginTop: '30px',
            }}
          >
                      <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <p style={{ margin: 0, lineHeight: '35px' }}>Join the waitlist now</p>
              <img
                src={ArrowDown}
                alt="Click to join the waiting list"
                style={{ width: '20px', cursor: 'pointer' }}
                onClick={() => {
                  const element = document.getElementById('LandingPage');

                  element.scrollTo({
                    top: element.scrollHeight - windowInnerSize.height * 2,
                  });
                }}
              />
            </div>
          </div> */}
        </div>
      </div>
    )
  );
};

export default EstimateSlide;
